import { HeadingGroup } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useCertificateUpdate from "./useCertificateUpdate";
import Select from "react-select";

const CertificateUpdateList = () => {
  const { formik, typeOptions } = useCertificateUpdate();

  return (
    <div>
      <HeadingGroup title={"Certificate Update"} className={`pro-mb-4`} />
      <div className="col-12 pro-pt-3 pro-pb-6">
        <div className="row gx-3 gy-4">
          <div className="col-md-4">
            <label
              htmlFor="gli_number"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              GLI Number
            </label>
            <input
              type="text"
              id="gli_number"
              name="gli_number"
              className={`pro-input lg ${
                formik.touched.gli_number && formik.errors.gli_number
                  ? "error"
                  : ""
              }`}
              value={formik.values.gli_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.gli_number && formik.errors.gli_number && (
              <span className="error-text">{formik.errors.gli_number}</span>
            )}
          </div>

          <div className="col-md-4">
            <label
              htmlFor="type"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              Type
            </label>
            <Select
              id="type"
              placeholder="Select Type"
              className="pro-input lg"
              classNamePrefix="pro-input"
              name="type"
              options={typeOptions}
              value={formik.values.type}
              onChange={(value) => formik.setFieldValue("type", value)}
              onBlur={formik.handleBlur}
              menuPlacement="auto"
            />
            {formik.touched.type && formik.errors.type && (
              <span className="error-text">{formik.errors.type}</span>
            )}
          </div>

          {formik.values.type?.value === "1" ? (
            <div className="col-md-4">
              <label
                htmlFor="from"
                className="pro-font-sm pro-mb-1 pro-fw-medium"
              >
                Certificate Number
              </label>
              <input
                type="text"
                id="from"
                name="from"
                className={`pro-input lg ${
                  formik.touched.from && formik.errors.from
                    ? "error"
                    : ""
                }`}
                value={formik.values.from}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.from && formik.errors.from && (
                <span className="error-text">{formik.errors.from}</span>
              )}
            </div>
          ) : (
            <>
              <div className="col-md-4">
                <label
                  htmlFor="from"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Certificate Number From
                </label>
                <input
                  type="text"
                  id="from"
                  name="from"
                  className={`pro-input lg ${
                    formik.touched.from && formik.errors.from
                      ? "error"
                      : ""
                  }`}
                  value={formik.values.from}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.from && formik.errors.from && (
                  <span className="error-text">{formik.errors.from}</span>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="to"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Certificate Number To
                </label>
                <input
                  type="text"
                  id="to"
                  name="to"
                  className={`pro-input lg ${
                    formik.touched.to && formik.errors.to
                      ? "error"
                      : ""
                  }`}
                  value={formik.values.to}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.to && formik.errors.to && (
                  <span className="error-text">{formik.errors.to}</span>
                )}
              </div>
            </>
          )}

          <div className="col-md-4">
            <label
              htmlFor="old_price"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              Old Price or Code
            </label>
            <input
              type="text"
              id="old_price"
              name="old_price"
              className={`pro-input lg ${
                formik.touched.old_price && formik.errors.old_price
                  ? "error"
                  : ""
              }`}
              value={formik.values.old_price}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.old_price && formik.errors.old_price && (
             <span className="error-text">
                {formik.errors.old_price}
              </span>
            )}
          </div>

          <div className="col-md-4">
            <label
              htmlFor="new_price"
              className="pro-font-sm pro-mb-1 pro-fw-medium"
            >
              New Price or Code
            </label>
            <input
              type="text"
              id="new_price"
              name="new_price"
              className={`pro-input lg ${
                formik.touched.new_price && formik.errors.new_price
                  ? "error"
                  : ""
              }`}
              value={formik.values.new_price}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.new_price && formik.errors.new_price && (
              <span className="error-text">
                {formik.errors.new_price}
              </span>
            )}
          </div>

          <div className="col-12">
            <button
              type="button"
              className="pro-btn pro-btn-primary"
              onClick={formik.handleSubmit}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateUpdateList;
